import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'btn-cell-renderer-delete',
    template: `	
		<em >
		<img style="cursor:pointer;" class="table_delete" src="./assets/images/delete_red.svg" 
		(click)="btnClickedHandler($event,'delete')">
		</em>`,
    standalone: false
})
export class BtnCellRendererDelete implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	agInit(params: any): void {

		this.params = params;
		this.pageName = this.params.colDef.field;
	}

	btnClickedHandler(_event, _action) {
		if (this.pageName == 'pcs_master_mini_left') {  // NOSONAR
			this.params.context.componentParent.pcsMasterLeftDelete(this.params.data, this.pageName);
		}

	}

	ngOnDestroy() {
console.info()


	}
}
